import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const PanelTitle = styled.h2`
  color: #2D3653;
  text-align: center;
  font-family: 'Style Script', cursive;
  font-size: clamp(16px, 1.5vw, 24px);
  margin-bottom: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    margin-bottom: 0;
  }
`;

const ContentWrapper = styled.div`
  overflow: hidden;
  height: calc(100% - 60px);
`;

const HolidayInfoContainer = ({
  isTransitioning,
  information,
  AnimatedContent
}) => {
  const { t } = useTranslation();

  return (
    <>
      <PanelTitle>{t('schedule.informationSection')}</PanelTitle>
      <ContentWrapper>
        <AnimatedContent $isEntering={!isTransitioning}>
          <div dangerouslySetInnerHTML={{ __html: information }} />
        </AnimatedContent>
      </ContentWrapper>
    </>
  );
};

export default HolidayInfoContainer; 